// import external dependencies
import 'jquery';


// Import Lightbox2
import 'lightbox2/dist/js/lightbox.min.js';

// Import Chosen
import 'chosen-js/chosen.jquery.min.js';

// Import jQuery Breakpoints
import 'jquery-breakpoints/jquery.breakpoints.min.js';

// Import masonry
import 'masonry-layout/dist/masonry.pkgd.min.js';

// Import imagesloaded
import 'imagesloaded/imagesloaded.pkgd.min.js';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleArticle from './routes/singleArticle';
import pageTemplatePageEducationalResources from './routes/pageTemplatePageEducationalResources';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  singleArticle,
  // Educational Resources template
  pageTemplatePageEducationalResources,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

window.WebFontConfig = {
  google: {
    families: [ 'Noto+Serif:700,700italic,italic,regular&subset=latin' ],
  },
  monotype: {
    projectId: 'ebc595e5-708b-4682-a1b1-23b31ece0575',
    version: 1,
    loadAllFonts: true,
  },
  custom: {
    families: [
      'Southern Spaces Icons',
      'Tiempos Headline:n2,i2,n4,i4,n5,i5,n6,i6,n7,i7,n9,i9',
      'Tiempos Text:n4,i4,n6,i6',
    ],
    urls: [
      '/wp-content/themes/longform/resources/assets/fonts/SouthernSpacesIcons/SouthernSpacesIcons.css',
      '/wp-content/themes/longform/resources/assets/fonts/TiemposHeadline/TiemposHeadline.css',
      '/wp-content/themes/longform/resources/assets/fonts/TiemposText/TiemposText.css',
    ],
  },
};
(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();



// WEBPACK FOOTER //
// ./scripts/main.js